import Popper from 'popper.js'

export default function textPopper(Vue) {
    Vue.directive('textPopper', {
        bind(el, binding) {
            initTextPopper(el)
        },

        update(el) {
            if (el.popper) {
                el.popper.destroy()
                el.popper = null
            }

            initTextPopper(el)
        },

        unbind(el) {
            if (el.popper) {
                el.popper.destroy()
                el.popper = null
                el.onmouseover = null
                el.onmouseout = null
                el.popperDom = null
            }
        }
    })
}

function initTextPopper(el) {
    el.onmouseover = function(event) {
        const wrapperWidth = event.currentTarget.clientWidth
        const realWidth = event.currentTarget.scrollWidth
        if (realWidth > wrapperWidth) {
            if (el.popper) {
                el.popperDom.style.display = 'block'
                el.popper.update()
            } else {
                const wrapper = document.createElement('div')
                wrapper.style.zIndex = '3000'
                wrapper.style.maxWidth = '260px' // 保证一行最多显示15个字
                const div = document.createElement('div')
                div.style.background = '#fff'
                div.style.padding = '10px'
                div.style.borderRadius = '4px'
                div.style.boxShadow = '0px 1px 2px 2px rgba(0, 0, 0, .1)'
                div.style.wordBreak = 'break-all'
                wrapper.appendChild(div)
                const i = document.createElement('i')
                i.className = 'el-icon el-icon-caret-bottom'
                i.style.color = '#fff'
                i.style.left = '50%'
                i.style.transform = 'translateX(-50%)'
                i.style.fontSize = '20px'
                i.style.position = 'absolute'
                i.style.bottom = '-12px'
                div.appendChild(i)
                const span = document.createElement('span')
                span.style.lineHeight = '20px'
                span.style.fontSize = '14px'
                span.innerText = event.currentTarget.innerText
                div.appendChild(span)
                document.body.appendChild(wrapper)
                el.popper = new Popper(event.currentTarget, wrapper, {
                    placement: 'top',
                    removeOnDestroy: true,
                    modifiers: {
                        offset: {
                            offset: '0,10px,0,0'
                        }
                    }
                })
                el.popperDom = wrapper
            }
        }
    }

    el.onmouseout = function() {
        if (el.popperDom) {
            el.popperDom.style.display = 'none'
        }
    }
}
